import { render, staticRenderFns } from "./Homeproduct.vue?vue&type=template&id=6af0fa34&scoped=true&"
import script from "./Homeproduct.vue?vue&type=script&lang=js&"
export * from "./Homeproduct.vue?vue&type=script&lang=js&"
import style0 from "./Homeproduct.vue?vue&type=style&index=0&id=6af0fa34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af0fa34",
  null
  
)

export default component.exports